import "%modules%/promo/promo";
import "%modules%/cookies/cookies";
import "%modules%/request/request";
